import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import { Link } from 'react-router-dom';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';
import AMPPodcastReadySection from '../AMPPodcastReadySection';
import Img from '../Img';

import styles from './styles.sass';

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

const METADATA = {
  TITLE: 'Features',
};

const AMPToolsPage = props => {
  const isAmp = props.context && props.context.isAmpRoute;
  return (
    <AMPPage isAmpRoute={isAmp} pathname="/features">
      <AMPPageHeader
        title="Anchor's Features"
        subtitle="Here are a few things that make Anchor different (and better) than the rest."
      />
      <div id="unlimitedHosting" className={styles.featureAnchor} />
      <AMPPageSection color="gray">
        <h2>Unlimited Free Hosting</h2>
        <Row className={styles.verticalAlign}>
          <Col xs={12} sm={8}>
            <h3>
              Hosting costs shouldn’t be the reason you don’t have a podcast.
            </h3>
            <p>
              We don’t believe in charging creators to make or store their
              content. Our mission is to democratize audio, making sure
              podcasting is accessible to everyone on the planet, so Anchor is
              completely free to use. No storage limits; no trial period; no
              strings attached. And nope, we don’t take any sort of payment
              information from you at any time.
            </p>
            <p>
              Wondering how can Anchor possibly be free? The real question is,
              why <em>aren’t</em> other podcast hosting services free?{' '}
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://medium.com/@NirZicherman/why-you-should-never-pay-for-podcast-hosting-9c39becd7cf7"
              >
                Read more from our co-founder
              </a>
              .
            </p>
          </Col>
          <Col xs={12} sm={4}>
            <div className={styles.alignedImg}>
              <Img
                isAmp={isAmp}
                alt="Unlimited Free Hosting"
                src={`${IMG_PREFIX}features-free-hosting.png`}
                withRetina
                layout="fixed"
                width={222}
                height={194}
              />
            </div>
          </Col>
        </Row>
      </AMPPageSection>
      <div id="distribution" className={styles.featureAnchor} />
      <AMPPageSection>
        <Row>
          <Col xs={12} sm={4}>
            <div className={styles.centeredImageContainer}>
              <Img
                isAmp={isAmp}
                alt="One-Click Distribution"
                src={`${IMG_PREFIX}features-one-click-distribution.png`}
                withRetina
                // layout="fixed"
                width={183}
                height={354}
              />
            </div>
          </Col>
          <Col xs={12} sm={8}>
            <h2>One-Click Distribution</h2>
            <h3>Unfamiliar with RSS? Cool, let’s keep it that way.</h3>
            <p>
              Easily distribute your podcast to every major podcast platform,
              including Apple Podcasts, Google Podcasts, and Spotify. (For a
              full list of currently supported platforms,{' '}
              <a href="http://anch.co/distribution">click here</a> - but we’re
              adding new ones all the time!) All it takes from you is one click;
              we handle everything else.
            </p>
            <p>
              Not sure which of these platform links to share with your
              listeners? Just share your Anchor profile, and they can choose to
              listen on whichever podcast app they prefer.
            </p>
            <p>
              Prefer to manage your RSS feed and distribution yourself? No
              problem. Our One-Click Distribution is completely optional.{' '}
            </p>
          </Col>
        </Row>
      </AMPPageSection>
      <div id="monetize" className={styles.featureAnchor} />
      <AMPPageSection color="gray">
        <Row>
          <Col xs={12} sm={8}>
            <h2>Monetize Your Podcast</h2>
            <h3>Anchor Sponsorships</h3>
            <p>
              We’ll do the work of matching you with great brands who are
              interested in sponsoring your show. You decide which brands you
              want to work with, which episodes you want to monetize, and where
              in your episodes you want your ads to appear. All Sponsorships ads
              are read by you, so you can blend them seamlessly into your show.
              Then, get paid whenever people listen! You can learn more{' '}
              <a href="/sponsorships">here</a>.
            </p>
            <h3>Listener Support</h3>
            <p>
              Add a button on your Anchor profile that lets any listener sign up
              for monthly donations to help keep your podcast going. They don’t
              even need an Anchor account to subscribe.
            </p>
            <div className={styles.centeredImageContainer}>
              <Link to="/dashboard">
                <button className={`cyanButton ${styles.monetizeButton}`}>
                  Start getting paid to podcast
                </button>
              </Link>
            </div>
          </Col>
          <Col xs={12} sm={4}>
            <div className={styles.alignedImg}>
              <Img
                isAmp={isAmp}
                alt="Monetization"
                src={`${IMG_PREFIX}features-monetization-sponsorships.png`}
                withRetina
                layout="fixed"
                width={183}
                height={354}
              />
            </div>
          </Col>
        </Row>
      </AMPPageSection>
      <div id="podcastWithFriends" className={styles.featureAnchor} />
      <AMPPageSection>
        <Row>
          <Col xs={12} sm={4}>
            <div className={styles.centeredImageContainer}>
              <Img
                isAmp={isAmp}
                alt="Podcast With Friends"
                src={`${IMG_PREFIX}features-rwf.png`}
                withRetina
                // layout="fixed"
                width={183}
                height={353}
              />
            </div>
          </Col>
          <Col xs={12} sm={8}>
            <h2>Podcast With Friends</h2>
            <h3>Podcasting is better together.</h3>
            <p>
              Got a cohost, or a different guest every episode? Anchor makes it
              easy to invite anyone to record with you – multiple people can
              join at a time, and they can be in any country in the world, as
              long as they have the Anchor app installed. (Yup, still 100%
              free.)
            </p>
          </Col>
        </Row>
      </AMPPageSection>
      <div id="analytics" className={styles.featureAnchor} />
      <AMPPageSection id="analytics" color="gray">
        <h2>Straightforward Analytics</h2>
        <h3>Convenient stats to help you track your podcast’s performance</h3>
        <p>
          Learn about your audience growth and easily track how your episodes
          are performing over time with Anchor’s easy-to-read analytics
          dashboard. See things like your plays over time, how episodes stack up
          to each other, and which apps people are using to listen.
        </p>
        <div className={styles.analyticsImg}>
          <Img
            isAmp={isAmp}
            alt="Podcast Analytics"
            src={`${IMG_PREFIX}tools-analytics.png`}
            withRetina
            layout="responsive"
            width={483}
            height={278}
          />
        </div>
      </AMPPageSection>
      <div id="recordAnywhere" className={styles.featureAnchor} />
      <AMPPageSection>
        <Row>
          <Col xs={12} sm={8}>
            <h2>Record From Anywhere</h2>
            <h3>The best microphone is whichever one you have with you.</h3>
            <p>
              Use Anchor’s recording tools on mobile (iOS and Android), iPad, or
              desktop web to easily record your voice with no extra equipment
              required. (If you want to, of course, you can also plug in an
              external microphone to any of these devices.) On mobile, you can
              invite anyone to record with you – multiple people can join at a
              time, and they can be in any country in the world, as long as they
              have the Anchor app installed.
            </p>
          </Col>
          <Col xs={12} sm={4}>
            <div className={styles.alignedImg}>
              <Img
                isAmp={isAmp}
                alt="Record From Anywhere"
                src={`${IMG_PREFIX}features-record.png`}
                withRetina
                layout="fixed"
                width={183}
                height={354}
              />
            </div>
          </Col>
        </Row>
      </AMPPageSection>
      <div id="episodeBuilder" className={styles.featureAnchor} />
      <AMPPageSection color="gray">
        <h2>Episode Builder</h2>
        <h3>An easier, more intuitive way to make your podcast.</h3>
        <p>
          The Anchor episode builder helps you craft your episodes using a
          visual list of segments, no editing required. Record, add other types
          of audio (like transitions or voice messages from your listeners),
          rearrange your segments however you want, and you’re done. There’s
          never been a more intuitive way to build a podcast episode.
        </p>
        <div className={styles.desktopImg}>
          <Img
            isAmp={isAmp}
            alt="Episode Builder"
            src={`${IMG_PREFIX}features-episode_builder.png`}
            withRetina
            layout="responsive"
            width={1357}
            height={791}
          />
        </div>
      </AMPPageSection>
      <div id="editingTools" className={styles.featureAnchor} />
      <AMPPageSection>
        <h2>Editing Tools</h2>
        <h3>
          Everything you need to make your podcast to sound great. No tutorials
          required.
        </h3>
        <p>
          After recording or importing audio, easily edit it right from your
          iPhone, iPad, or Android device (coming soon to Anchor’s desktop web
          experience). Because our editing tools were designed specifically for
          podcasting, they’re uncomplicated and easy to learn. Just trim the
          start/end of your audio and remove whatever segments you don’t want to
          keep, and you’re done!
        </p>
        <div className={styles.centeredImageContainer}>
          <div className={styles.editingToolsImage}>
            <Img
              isAmp={isAmp}
              alt="Editing tools"
              src={`${IMG_PREFIX}features-editing-tools.png`}
              withRetina
              layout="responsive"
              width={576}
              height={305}
            />
          </div>
        </div>
      </AMPPageSection>
      <div id="creationTools" className={styles.featureAnchor} />
      <AMPPageSection color="gray">
        <h2>Creation Tools</h2>
        <h3>Take voice messages from your listeners.</h3>
        <p>
          Gone are the days where you need to recite a phone number for your
          listeners to call into to leave voicemail. All they need to do is tap
          a button to send you an Anchor voice message. You can see who each one
          is from and the title of the voice message so you can quickly find
          what you’re looking for. Then, just add your favorites to your next
          episode with a single tap!
        </p>
        <h3>Import or upload existing audio.</h3>
        <p>
          Whether you’re on web or mobile, it’s also easy to pull in audio
          you’ve created in other apps. There’s no limit to how long an imported
          file can be, and you can mix-and-match with native Anchor audio.
          (Think: importing your theme song and intro, recording a segment on
          the go from your phone, and then adding a voice message from a
          listener to complete your episode.)
        </p>
        <h3>Add transitions, sound effects, and background music.</h3>
        <p>
          With Anchor, you can easily add background tracks behind any segment
          or break up longer recordings using our library of built-in
          transitions and sound effects. Everything’s just a tap away!
        </p>
        <h3>
          Add music from Apple Music or Spotify (playable in Anchor only).
        </h3>
        <p>
          Search for any song on Apple Music or Spotify and add it to your
          episodes as a bonus for your listeners on Anchor.
        </p>
        <div>
          <Img
            isAmp={isAmp}
            alt="Creator Tools"
            src={`${IMG_PREFIX}screens/features/tools.png`}
            withRetina
            layout="responsive"
            width={774}
            height={296}
          />
        </div>
      </AMPPageSection>
      <div id="transcribedVideos" className={styles.featureAnchor} />
      <AMPPageSection>
        <h2>Transcribed Videos</h2>
        <h3>Share video highlights of your podcast on social.</h3>
        <p>
          We’ll generate an automatically transcribed video for any audio
          segment under 1 minute long. Any time you want to promote your
          podcast, you can easily share a beautiful, animated video to your
          social networks or to YouTube that’s customized to your cover art. You
          can export these videos in sizes perfect for Twitter, Facebook, or
          Instagram (feed or stories!), and because they’re transcribed, your
          followers will be able to get a sense for what’s in your episode, even
          if their device is muted.
        </p>
        <div className={styles.transcriptionImg}>
          <Img
            isAmp={isAmp}
            alt="Podcast Transcription Text"
            src={`${IMG_PREFIX}how-to-start-a-podcast-transcription-2.png`}
            withRetina
            width={368}
            height={206}
            layout="responsive"
          />
        </div>
      </AMPPageSection>
      <div id="switch" className={styles.featureAnchor} />
      <AMPPageSection color="gray">
        <h2>Switch to Anchor</h2>
        <h3>Move your podcast to Anchor and never pay for hosting again.</h3>
        <p>
          Our <a href="/onboarding/rss">easy import tool</a> makes it completely
          painless to move your podcast over from your old host. You’ll retain
          your existing presence on all listening apps, and you’ll be able to
          make future episodes right from Anchor.
        </p>
      </AMPPageSection>
      <AMPPodcastReadySection />
    </AMPPage>
  );
};

export { AMPToolsPage as default, METADATA };
